export enum UserLanguageEventTypes {
  FETCH_USER_LANGUAGE_REQUEST = 'FETCH_USER_LANGUAGE_REQUEST',
  FETCH_USER_LANGUAGE_RESPONSE = 'FETCH_USER_LANGUAGE_RESPONSE',
  USER_LANGUAGE_UPDATED = 'USER_LANGUAGE_UPDATED',
}
